import * as angular from "angular";
import {ResourceAllocationEditType} from "../types/resourceAllocationEdit.type";
import {IHttpService, IQService} from "angular";
import {SplitService} from "../../commons/services/split-service.service";
import {ApiConfig} from "../../commons/models/api-config.model";
import {BulkUpdateResourceAllocationRequest} from "../models/Bulk-update-resource-allocation-request.model";

export class ResourcesRequestsService {

  /* @ngInject */
  constructor(private apiConfig: ApiConfig, private $q: IQService, private $http: IHttpService,
              private splitService: SplitService, private Upload, private $resourceAllocations,
              private $scheduleBinding, private ResourcesAllocationsApi, private scheduleBindingApi) {
  }

  // ******************************
  //        Public methods
  // ******************************

  getResources(branchIds, agentType, serviceAreaIds, isActive, agentSkills, tags) {
    const api = this.ResourcesAllocationsApi.actions.getResources;
    return this.$$callResourceAllocations(api, {
      branchIds: branchIds,
      agentType: agentType,
      serviceAreaIds: serviceAreaIds,
      skill: agentSkills,
      isActive: isActive,
      tags: tags
    }, {}, {});
  }

  getResourcesByIds(ids?) {
    const api = this.ResourcesAllocationsApi.actions.getResourcesByIds;
    return this.$$callResourceAllocations(api, {ids: ids}, {}, {});
  }


  getResourcesAllocationsByAgents(agentIds?, from?, to?) {
    const api = this.ResourcesAllocationsApi.actions.getResourcesAllocationsByAgents;
    return this.$$callResourceAllocations(api, {
      agentIds: agentIds,
      from: from,
      to: to
    }, {}, {});
  }

  createResource(resource) {
    const api = this.ResourcesAllocationsApi.actions.createResource;
    return this.$$callResourceAllocations(api, {}, resource, {});
  }

  updateResource(resource, resourceId, addServiceAreasToTw?, overrideTwBranches?: boolean) {
    const api = this.ResourcesAllocationsApi.actions.updateResource;
    return this.$$callResourceAllocations(api, {
      addServiceAreasToTw: addServiceAreasToTw,
      overrideTwBranches: overrideTwBranches
    }, resource, {resourceId: resourceId});
  }

  duplicateResource(resourceId, name, externalId) {
    const api = this.ResourcesAllocationsApi.actions.duplicateResource;
    return this.$$callResourceAllocations(api, {
      name: name,
      externalId: externalId
    }, {}, {resourceId: resourceId});
  }

  deleteResource(resourceId, deleteActiveRelatedRoute: boolean) {
    const api = this.ResourcesAllocationsApi.actions.deleteResource;
    return this.$$callResourceAllocations(api, {deleteActiveRelatedRoute: deleteActiveRelatedRoute}, {}, {resourceId: resourceId});
  }

  getAllocationsTimeWindows(from, to, resourceIds: string[], branchIds: string[], serviceAreaIds: string[]) {
    const api = this.ResourcesAllocationsApi.actions.getAllocationsTimeWindows;
    return this.$$callResourceAllocations(api, {
      from: from,
      to: to,
      resourceIds: resourceIds,
      branchIds: branchIds,
      serviceAreaIds: serviceAreaIds,
    }, {}, {});
  }

  getAllocations(from?, to?, resourceIds?, branchIds?, serviceAreaIds?, locationSequenceIds?: string[]) {
    const api = this.ResourcesAllocationsApi.actions.getAllocations;
    return this.$$callResourceAllocations(api, {
      from: from,
      to: to,
      resourceIds: resourceIds,
      branchIds: branchIds,
      serviceAreaIds: serviceAreaIds,
      locationSequenceIds: locationSequenceIds
    }, {}, {});
  }

  getAllocationsInstances(from?, to?, branchIds?, skills?, serviceAreaIds?, agentType?) {
    const api = this.ResourcesAllocationsApi.actions.getAllocationsInstances;
    return this.$$callResourceAllocations(api, {
      siteId: this.splitService.getSiteId(),
      from: from,
      to: to,
      branchIds: branchIds,
      serviceAreaIds: serviceAreaIds,
      agentType: agentType,
      skill: skills
    }, {}, {});
  }


  createResourceAllocation(resourceId, allocation) {
    const api = this.ResourcesAllocationsApi.actions.createResourceAllocation;
    return this.$$callResourceAllocations(api, {}, allocation, {resourceId: resourceId});
  }


  updateResourceAllocation(resourceId, allocation, type?: ResourceAllocationEditType, date?: string) {
    const api = this.ResourcesAllocationsApi.actions.updateResourceAllocation;
    return this.$$callResourceAllocations(api, {type: type, date: date}, allocation, {
      resourceId: resourceId,
      allocationId: allocation.id
    });
  }

  deleteResourceAllocation(resourceId, allocationId, changeType, eventInstanceDate) {
    const api = this.ResourcesAllocationsApi.actions.deleteResourceAllocation;
    return this.$$callResourceAllocations(api, {
      type: changeType,
      date: eventInstanceDate
    }, {}, {resourceId: resourceId, allocationId: allocationId});
  }

  getAnalysis(from?, to?, resourceIds?, branchIds?, serviceAreaIds?) {
    const api = this.ResourcesAllocationsApi.actions.getAnalysis;
    return this.$$callResourceAllocations(api, {
      from: from,
      to: to,
      resourceIds: resourceIds,
      branchIds: branchIds,
      serviceAreaIds: serviceAreaIds,
      zoneId: this.splitService.getTimeZone()
    }, {}, {});
  }

  exportAllocations(branchIds, agentType, agentSkills, serviceAreaIds, isActive, from, to, tags) {
    const api = this.ResourcesAllocationsApi.actions.exportAllocations;
    return this.$$callResourceAllocations(api, {
      branchIds: branchIds,
      agentType: agentType,
      skill: agentSkills,
      serviceAreaIds: serviceAreaIds,
      isActive: isActive,
      from: from,
      to: to,
      tags: tags,
      zoneId: this.splitService.getTimeZone()
    }, {}, {});
  }

  exportResources(branchIds, agentType, agentSkills, serviceAreaIds, isActive, from, to, tags) {
    const api = this.ResourcesAllocationsApi.actions.exportResources;
    return this.$$callResourceAllocations(api, {
      branchIds: branchIds,
      agentType: agentType,
      skill: agentSkills,
      serviceAreaIds: serviceAreaIds,
      isActive: isActive,
      from: from,
      to: to,
      tags: tags,
      zoneId: this.splitService.getTimeZone()
    }, {}, {});
  }

  exportResourcesAllocationSequences(branchIds, agentType, agentSkills, serviceAreaIds, isActive, from, to, tags) {
    const api = this.ResourcesAllocationsApi.actions.exportResourcesAllocationSequences;
    return this.$$callResourceAllocations(api, {
      branchIds: branchIds,
      agentType: agentType,
      skill: agentSkills,
      serviceAreaIds: serviceAreaIds,
      isActive: isActive,
      from: from,
      to: to,
      tags: tags,
      zoneId: this.splitService.getTimeZone()
    }, {}, {});
  }

  uploadAllocations(defaultVehicleId, agentType, skills, file) {
    const api = this.ResourcesAllocationsApi.actions.uploadAllocations;
    return this.$$callResourceAllocations(api, {
      defaultVehicleId: defaultVehicleId,
      defaultAgentType: agentType,
      defaultSkills: skills,
      zoneId: this.splitService.getTimeZone()
    }, {file: file}, {});
  }

  getLogsTimeline(resourceId, from, to) {
    const api = this.ResourcesAllocationsApi.actions.getLogsTimeline;
    return this.$$callResourceAllocations(api, {
      from: from,
      to: to
    }, {}, {resourceId: resourceId});
  }

  getResourceActiveRoutes(resourceId) {
    const api = this.ResourcesAllocationsApi.actions.getResourceActiveRoutes;
    return this.$$callResourceAllocations(api, {}, {}, {resourceId: resourceId});
  }


  getResourceAllocationInstance(resourceAllocationInstanceId) {
    const api = this.ResourcesAllocationsApi.actions.getResourceAllocationInstance;
    return this.$$callResourceAllocations(api, {}, {}, {resourceAllocationInstanceId: resourceAllocationInstanceId});
  }

  getResourceAllocation(resourceId: string, resourceAllocationId: string) {
    const api = this.ResourcesAllocationsApi.actions.getResourceAllocation;
    return this.$$callResourceAllocations(api, {}, {}, {resourceId: resourceId, id: resourceAllocationId});
  }

  getResourceAllocationsInstances(branchIds?, from?, to?, skills?, isActive?, excludeRouted?: boolean) {
    const api = this.ResourcesAllocationsApi.actions.getResourceAllocationsInstances;
    return this.$$callResourceAllocations(api, {
      branchIds: branchIds,
      from: from,
      to: to,
      skills: skills,
      isActive: isActive,
      excludeRouted: excludeRouted,
      excludeBlockedToRouting: true
    }, {}, {});
  }

  bulkUpdateTimeWindows(data, queryParams) {
    const api = this.ResourcesAllocationsApi.actions.bulkUpdateTimeWindows;
    return this.$$callResourceAllocations(api, {
      ...queryParams,
      zoneId: this.splitService.getTimeZone()
    }, {...data, zoneId: this.splitService.getTimeZone()}, {});
  }

  bulkUpdateResourceAllocation(payload: BulkUpdateResourceAllocationRequest) {
    const api = this.ResourcesAllocationsApi.actions.bulkUpdateResourceAllocation;
    return this.$$callResourceAllocations(api, {}, payload, {});
  }

  deleteResourceAgentAllocation(payload) {
    const api = this.scheduleBindingApi.actions.deleteResourceAgentAllocation;
    return this.$$callScheduleBinding(api, {}, payload, {});
  }

  createAgentAllocationBinding(payload) {
    const api = this.scheduleBindingApi.actions.createAllocationBinding;
    return this.$$callScheduleBinding(api, {}, payload, {});
  }

  bulkCreateAgentAllocationsBinding(payload) {
    const api = this.scheduleBindingApi.actions.bulkCreateAllocationBinding;
    return this.$$callScheduleBinding(api, {}, payload, {});
  }


  getAgentAllocationBindings(from, to, agentType, branchIds?: string[], ignoreSchedules?: boolean) {
    const api = this.scheduleBindingApi.actions.getAgentAllocationBindings;
    return this.$$callScheduleBinding(api, {
      from: from,
      to: to,
      agentType: agentType,
      branchIds: branchIds,
      ignoreSchedules: ignoreSchedules
    }, {}, {});
  }

  addServiceSequence(resourceId, allocationId, payload, date?, type?) {
    const api = this.ResourcesAllocationsApi.actions.addServiceSequence;
    const zoneId = this.splitService.getTimeZone()
    return this.$$callResourceAllocations(api, {
      date: date,
      type: type,
      zoneId: zoneId
    }, payload, {resourceId: resourceId, allocationId: allocationId});
  }

  getConnectedResourcesByServiceAreas(branchId: string, addedAreaIds: string[], removedAreaIds: string[]) {
    const api = this.ResourcesAllocationsApi.actions.getConnectedResourcesByServiceAreas;
    return this.$$callResourceAllocations(api, {branchId: branchId}, {
      addedAreaIds: addedAreaIds,
      removedAreaIds: removedAreaIds
    }, {});
  }

  //calls functions
  private $$callResourceAllocations(apiCall, params, data, options) {
    return this.$resourceAllocations().$call(apiCall, params, data, options);
  }

  private $$callScheduleBinding(apiCall, params, data, options) {
    return this.$scheduleBinding().$call(apiCall, params, data, options);
  }

}

angular
  .module('bringoz.admin.resources')
  .service('resourcesRequestsService', ResourcesRequestsService);
